import {
    Container, Icon,
    Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'

import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { useLandingZones } from '@features/hooks/LandingZones'
import { useLandingZoneGroups } from '@features/hooks/LandingZones/groups'

import Alert from '@components/Alert'
import CollapsibleTable from '@components/CollapsibleTable'

import Nodata from '@views/Components/Nodata'
import Group from '@views/Landingzones/Detail/Groups/Group'
import Membership from '@views/Landingzones/Detail/Components/Membership'

import { HEADER_HEIGHT } from '@services/theme'

export const Groups = (props) => {
    const lzDataStore = useSelector(state => state.landingZones)
    const dataStore = useSelector(state => state.landingZoneGroups)

    const { load: loadLz, getProvider } = useLandingZones()
    const { load: loadGroups } = useLandingZoneGroups()

    const [data, setData] = useState([])
    const [provider, setProvider] = useState(null)

    useEffect(() => {
        if (!(lzDataStore.formated.mode > -1))
            loadLz(() => { loadGroups(props.id) })
        else loadGroups(props.id)
    }, [])

    useEffect(() => {
        setData(dataStore.formated)
        if (dataStore?.loaded) setProvider(getProvider(dataStore?.loaded))
    }, [dataStore.formated])

    const headers = useRef([
        {field: 'name', headerName: 'Name', isFirst: true},
        {field: 'objectId', headerName: 'Object ID'},
        {field: 'type', headerName: 'Type'}
    ])

    return (
        <Container maxWidth={'xl'} sx={{mt: 2}}>
            <Alert sx={{mb: 2}} description={'The groups provided at the creation of the landing zone allow to define the roles of the team members.'} />
            <Accordion sx={{mb: 2}}>
                <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
                    <strong>Group description</strong>
                </AccordionSummary>
                <AccordionDetails>
                    <Group provider={provider} name={props.id} />
                </AccordionDetails>
            </Accordion>

            {(data && data.length > 0) && (
                <CollapsibleTable
                    headers={headers.current}
                    rows={data}
                    stickyHeader
                    sxGrid={{height: `calc(100vh - (${HEADER_HEIGHT} + 325px))`}}
                >
                    <Membership />
                </CollapsibleTable>
            )}

            {(data && data.length < 1) && (<Nodata label={'No data to display'} icon={'search_off'} noIcon img />)}
        </Container>
    )
}

export default Groups